<template>
  <div class="WaveContainer">

    <slot>
    </slot>

  </div>
</template>

<script>

//import component from '@assets/components/component.vue'

export default {
  name: 'WaveContainer',
  components: {
    //component
  },
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.WaveContainer{
  width: 100%;
  -webkit-animation: wave 5s ease-in-out infinite;
}

@-webkit-keyframes wave {
  0%   {transform: translate(-10%) scaleX(1.2);}
  50%  {transform: translate(10%) scaleX(1.2);}
  100% {transform: translate(-10%) scaleX(1.2);}
}

img{
  width: 100%;
}

</style>
